import React from 'react';

/** Футер: только копирайт. Кнопка поддержки — глобальная зелёная (SupportButton). */
export default function LmFooter() {
  return (
    <footer className="lm-footer">
      <span className="lm-footer__copy">©2026 ЛИМИТЕК</span>
    </footer>
  );
}
